<loading-indicator *ngIf="!formReady"></loading-indicator>
<div *ngIf="formReady" [formGroup]="formData" class="reportsSearchFormContainer">
  {{selectedItem?.Oid}}
  {{selectsedItemType}}
  <div class="searchFormContainerLeft">
    <table aria-hidden="true">
      <tbody>
        <tr>
          <td class="LabelContainer dialogTableCellPaddingTop">
            <span class="dialogLabel uppercase">{{ 'report.oid' | translate }}</span>
          </td>
        </tr>
        <tr>
          <td class="FieldContainer">
            <kendo-numerictextbox style="width: 100%;" formControlName="reportId" format="#" [spinners]="false"></kendo-numerictextbox>
          </td>
        </tr>
        <tr>
          <td class="LabelContainer dialogTableCellPaddingTop">
            <span class="dialogLabel uppercase">{{ 'report.valuer' | translate }}</span>
          </td>
        </tr>
        <tr>
          <td class="FieldContainer">
            <input style="width: 100%" formControlName="valuer" />
          </td>
        </tr>
        <tr>
          <td class="LabelContainer dialogTableCellPaddingTop">
            <span class="dialogLabel uppercase">{{ 'report.propertyMunicapelDescription' | translate }}</span>
          </td>
        </tr>
        <tr>
          <td class="FieldContainer">
            <input style="width: 100%" formControlName="community" />
          </td>
        </tr>
        <tr>
          <td class="LabelContainer dialogTableCellPaddingTop">
            <span class="dialogLabel uppercase">{{ 'report.street' | translate }}</span>
          </td>
        </tr>
        <tr>
          <td class="FieldContainer">
            <input style="width: 100%" formControlName="street" />
          </td>
        </tr>
        <tr>
          <td class="LabelContainer dialogTableCellPaddingTop">
            <span class="dialogLabel uppercase">{{ 'report.puid' | translate }}</span>
          </td>
        </tr>
        <tr>
          <td class="FieldContainer">
            <span *ngIf="selectedItemType === 'projectstd'" class="dialogLabel">{{selectedItem.Oid}}, {{selectedItem.Name}}</span>
            <span *ngIf="selectedItemType === 'valuationPortfolio'" class="dialogLabel">{{selectedItem.ProjectLongDescription}}</span>
            <input *ngIf="selectedItemType !== 'projectstd' && selectedItemType !== 'valuationPortfolio'" style="width: 100%" formControlName="puid" />
          </td>
        </tr>
        <tr>
          <td class="LabelContainer dialogTableCellPaddingTop">
            <span class="dialogLabel uppercase">{{ 'report.valuationPortfolio' | translate }}</span>
          </td>
        </tr>
        <tr>
          <td class="FieldContainer">
            <span *ngIf="selectedItemType === 'valuationPortfolio'" class="dialogLabel">{{selectedItem.ValuationPortfolioName}}</span>
            <input *ngIf="selectedItemType !== 'valuationPortfolio'" style="width: 100%" formControlName="valuationPortfolio" />
          </td>
        </tr>
        <tr>
          <td class="LabelContainer FieldContainer" style="padding-top: 10px;">
            <input type="checkbox" id="includeFinalized" class="k-checkbox" formControlName="includeFinalized">
            <label class="k-checkbox-label k-checkbox-label-uppercase dialogLabel" for="includeFinalized">{{ 'report.includeFinalized' | translate }}</label>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

